import React from "react";
import type { PackType } from "../../../../../../common-deprecated/types/CommonTypes";
import Price from "../common/price/Price";
import * as Image from "../../../../../../common-deprecated/styles/v2/toyota/globals/Image";
import * as Button from "../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Styles from "./styles/OptionalFinancePackEquipment";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import useFinancePackConfigurables from "../../../hooks/shared/financepacks/useFinancePackConfigurables";
import type { FinancePackConfigurablesType } from "../../../../../shared-logic/types/FinanceTypes";

type StandardFinancePackEquipmentType = {
    equipment: FinancePackConfigurablesType;
    pack: PackType;
};

const OptionalFinancePackContent = (props: StandardFinancePackEquipmentType): JSX.Element => {
    const { equipment, pack } = props;
    const { isChecked, onChange } = useFinancePackConfigurables(equipment, pack);

    return (
        <Styles.Wrapper selected={isChecked}>
            {equipment.image && (
                <Styles.Image>
                    <Image.ImageFluid src={equipment.image} alt={equipment.name} />
                </Styles.Image>
            )}
            <Styles.Content>
                <Styles.Title>{equipment.name}</Styles.Title>
                <Price price={equipment.price} />
            </Styles.Content>
            <Styles.Actions>
                <Button.Checkbox type="button" selected={isChecked} onClick={() => onChange(isChecked)}>
                    <Icon variant={isChecked ? "close" : "plus"} />
                </Button.Checkbox>
            </Styles.Actions>
        </Styles.Wrapper>
    );
};

export default OptionalFinancePackContent;
